import { Address } from '@ton/core';

export const TON_CONNECT_UI_DISCONNECTION_EVENT = 'ton-connect-ui-disconnection';

export interface TonConnectUiDisconnection {
  type: 'disconnection';
  scope: 'dapp';
  wallet_address: string;
  custom_data?: {
    chain_id?: string | null;
  };
}

let programmaticDisconnects = 0;

function isTonConnectUiDisconnection(value: unknown): value is TonConnectUiDisconnection {
  if (!value || typeof value !== 'object') return false;
  const event = value as Partial<TonConnectUiDisconnection>;
  return (
    event.type === 'disconnection' &&
    event.scope === 'dapp' &&
    typeof event.wallet_address === 'string'
  );
}

export function subscribeToTonConnectUiDisconnection(
  callback: (address: string) => void,
): () => void {
  const listener = (event: Event) => {
    const detail = (event as CustomEvent<unknown>).detail;
    if (programmaticDisconnects !== 0 || !isTonConnectUiDisconnection(detail)) return;
    try {
      callback(
        Address.parse(detail.wallet_address).toString({
          bounceable: false,
          testOnly: detail.custom_data?.chain_id === '-3',
        }),
      );
    } catch {
      return;
    }
  };
  window.addEventListener(TON_CONNECT_UI_DISCONNECTION_EVENT, listener);
  return () => window.removeEventListener(TON_CONNECT_UI_DISCONNECTION_EVENT, listener);
}

export async function disconnectForReauthentication(
  disconnect: () => Promise<void>,
): Promise<void> {
  programmaticDisconnects += 1;
  try {
    await disconnect();
  } finally {
    programmaticDisconnects -= 1;
  }
}
